import { render, staticRenderFns } from "./PagjLayout.vue?vue&type=template&id=0628f94f&scoped=true&"
import script from "./PagjLayout.vue?vue&type=script&lang=js&"
export * from "./PagjLayout.vue?vue&type=script&lang=js&"
import style0 from "./PagjLayout.vue?vue&type=style&index=0&id=0628f94f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0628f94f",
  null
  
)

export default component.exports